import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/hospital.png";
import Imagen2 from "../../../images/modulo12/mariocama.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad1.mp3";

const Actividad2 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[0];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[1].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[1].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[12].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[12].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>Observa las imágenes que se presentan a continuación:</li>
      </ul>

      <div className="row">
        <div className="col-lg-10 col-12">
          <img src={Imagen1} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-lg-10 col-12">
          <img src={Imagen2} className="img-fluid" alt="Peruanos" />
        </div>
        <div className="col-lg-10 col-12">
          <ul className="mt-5">
            <li>
              Ahora piensa y conversa con tu profesor, profesora o algún
              familiar sobre lo siguiente:
            </li>
          </ul>
          <div>
            <p>¿Qué ocurre con Brayan y con Mario?</p>
            <textarea className="form-control mb-3" rows={3} />
            <p>¿Está preocupada la mamá de Brayan? ¿Por qué?</p>
            <textarea className="form-control mb-3" rows={3} />
            <p>¿Está preocupada la mamá de Mario? ¿Por qué?</p>
            <textarea className="form-control mb-3" rows={3} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Comente a niños y niñas que están iniciando una nueva unidad de
            contenido. En esta unidad, se enfatizará la deliberación, es decir,
            el diálogo y la reflexión que acompañan la toma de posición con
            respecto a un tema.
          </li>
          <li>
            Mencione a niños y niñas que en estas trabajarán con la observación
            de imágenes. A partir de ellas, explicarán sus puntos de vista y
            dialogarán para comprender opiniones distintas.
          </li>
          <li>
            Lea la primera indicación: Observa las imágenes que se presentan a
            continuación.
          </li>
          <li>
            Presente algunas preguntas orientadoras para la observación de
            imágenes. Por ejemplo, propóngales que se fijen en lo siguiente:
            <ul>
              <li>
                <i>
                  “¿Quiénes aparecen en las imágenes? ¿En qué lugar transcurren
                  ambas historias? ¿Qué se están imaginando las mamás?”
                </i>
              </li>
            </ul>
          </li>
          <li>
            Lea las demás indicaciones: Ahora piensa y conversa con tu profesor,
            profesora o familiar sobre lo siguiente:
            <ul>
              <li>
                <i>
                  ¿Qué ocurre con Brayan y con Mario? ¿Está preocupada la mamá
                  de Brayan? ¿Por qué?¿Está preocupada la mamá de Mario? ¿Por
                  qué?
                </i>
              </li>
            </ul>
          </li>
          <li>
            Intente orientar las respuestas. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Qué ocurre con Brayan y con Mario? (Posible respuesta: Están
                  enfermos). ¿Cómo sabemos que están enfermos? (En la primera
                  imagen Brayan parece que está tosiendo y en la segunda imagen,
                  Mario está con fiebre). ¿Está preocupada la mamá de Brayan?
                  ¿Por qué? (Su mamá no está preocupada porque sabe que pronto
                  le darán la medicina para curarlo). ¿Está preocupada la mamá
                  de Mario? ¿Por qué? (Su mamá está preocupada porque tendrá que
                  ir a la farmacia a comprar las medicinas que probablemente le
                  costarán mucho dinero). ¿Por qué creen que existen estas
                  diferencias entre ambas familias? (Es probable que la mamá de
                  Brayan pueda pagar un seguro de salud y la mamá de Mario,
                  no).”
                </i>
              </li>
            </ul>
          </li>
          <li>
            Cierre la actividad mencionando que ambas situaciones ocurren en
            nuestro país, es decir, hay algunas personas que acceden a un buen
            servicio de salud mientras que otras no pueden hacerlo. El acceso
            diferente al servicio de salud es un ejemplo de la desigualdad que
            existe en el país.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
